const HistoryStatus = [
  {
    // 待領取
    label: "入櫃通知",
    value: "wait_collect",
    takeOutBy: null,
    takeOutByLabel: "",
    takeOutByLabelColor: null,
    labelTagColor: "red",
    labelTagName: "未領取"
  },
  {
    // 逾期催領
    label: "逾期催領",
    value: "wait_collect_overdue_alarm",
    takeOutBy: null,
    takeOutByLabel: "",
    takeOutByLabelColor: null,
    labelTagColor: "red",
    labelTagName: "未領取"
  },
  {
    // 自行取出
    label: "包裹取出",
    value: "collected_by_self",
    takeOutBy: "household",
    takeOutByLabel: "住戶",
    takeOutByLabelColor: null,
    labelTagColor: "gold",
    labelTagName: "已取回"
  },
  {
    // 管理員取出
    label: "包裹取出",
    value: "collected_by_manager",
    takeOutBy: "manager",
    takeOutByLabel: "管理員",
    takeOutByLabelColor: "blue",
    labelTagColor: null,
    labelTagName: "已領取"
  },
  {
    // 逾期取出
    label: "包裹取出",
    value: "collected_overdue",
    takeOutBy: "household",
    takeOutByLabel: "住戶",
    takeOutByLabelColor: null,
    labelTagColor: null,
    labelTagName: "已領取"
  },
  {
    // 取貨完成
    label: "包裹取出",
    value: "collected_by_other",
    takeOutBy: "household",
    takeOutByLabel: "住戶",
    takeOutByLabelColor: null,
    labelTagColor: null,
    labelTagName: "已領取"
  }
];

export const smartLockerPackageCodeList = {
  HistoryStatusArray: HistoryStatus,
  HistoryStatusMap: HistoryStatus.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {})
};
